import { render, staticRenderFns } from "./envelope-status.vue?vue&type=template&id=19200498"
import script from "./envelope-status.vue?vue&type=script&lang=js"
export * from "./envelope-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports